import { http } from 'http';

export default {
  deleteOperation: operationId => http.delete(`/operations/${operationId}`)
};
